import React, { useState, useEffect } from "react";
import axiosClient from "../../axios-client";

const PaymentStatus = () => {
  const [modalMessage, setModalMessage] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const paymentId = query.get("paymentId");
    const payerId = query.get("PayerID");

    if (paymentId && payerId) {
      axiosClient
        .get(
          `/subscriptions/paypal/success?paymentId=${paymentId}&PayerID=${payerId}`
        )
        .then((response) => {
          if (
            response.data.message ===
            "Payment successful, subscription updated!"
          ) {
            setModalMessage(
              "Payment successful! Your subscription is now active."
            );
          } else {
            setModalMessage(
              "Payment was successful, but there was an issue updating your subscription."
            );
          }
          setModalVisible(true);
        })
        .catch((error) => {
          console.error("Error handling payment success:", error);
          setModalMessage("An error occurred while finalizing the payment.");
          setModalVisible(true);
        });
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md w-full">
        <h2 className="text-2xl font-bold font-poppins text-gray-800 mb-4">
          Payment Status
        </h2>
        <p className="text-gray-600 mb-6">
          {modalMessage || "Processing payment status..."}
        </p>
        <button
          onClick={() => (window.location.href = "/profile")}
          className="bg-pink text-white px-6 py-2.5 rounded-lg font-medium hover:bg-pink-600 transition-colors"
        >
          Go to Profile
        </button>
      </div>
    </div>
  );
};

export default PaymentStatus;
